const settingsReducer = (state = null, action) => {
  switch(action.type) {
    case 'TEST_ACTION':
      return state;
    case 'SETTINGS_NEXT_STEP':
      return {
        ...state,
        step: action.step
      }
    case 'SETTINGS_SELECT_BACKGROUND':
      return {
        ...state,
        background: action.background,
        backgroundSrc: action.backgroundSrc,
        backgroundColor: action.backgroundColor
      }
    case 'SETTINGS_SELECT_FOREGROUND':
      return {
        ...state,
        foregroundSrc: action.foregroundSrc
      }
    case 'SETTINGS_SELECT_IMAGE':
      return {
        ...state,
        images: [
          ...state.images,
          action.image
        ]
      }
    case 'SETTINGS_UPDATE_IMAGE':
      return {
        ...state,
        images: [
          ...state.images.slice(0, action.index),
          action.image,
          ...state.images.slice(action.index + 1)
        ]
      }
    case 'SETTINGS_REMOVE_IMAGE':
      return {
        ...state,
        images: [
          ...state.images.slice(0, action.index),
          ...state.images.slice(action.index + 1)
        ]
      }
    case 'SETTINGS_ADD_IMAGE_TO_CART':
      return {
        ...state,
        cart: [
          ...state.cart,
          action.image
        ]
      }
    case 'SETTINGS_REMOVE_IMAGE_FROM_CART':
      return {
        ...state,
        cart: [
          ...state.cart.slice(0, action.index),
          ...state.cart.slice(action.index + 1)
        ]
      }
    case 'SETTINGS_RESET':
      return {
        step: 2,
        apiVersion: state.apiVersion,
        background: null,
        backgroundSrc: null,
        backgroundColor: "Default",
        images: [],
        cart: state.cart
      }
    default:
      return state;
  }
};

export default settingsReducer

